<template>
    <div class="container">
        <img :src="userInfo.avatar" alt="" class='avatar'  @click="showDetail">
        <div class='name' v-html="cName">{{ userInfo.name }}</div>
        <div class='posi'>{{userInfo.title}}</div>
        <div class='zan' @click="addVote">
            <img src="../assets/zan.png" alt=""><span>{{userInfo.number}}</span> 
        </div>
    </div>
</template>
<script>
export default {
    name:"user",
    props: {
      userInfo: {
        type: Object,
        required: true
      },
      searchName: String,
      searchMatch: Boolean,
      searchCurrent: Boolean
    },

  methods: {
    showDetail() {
      this.$emit('showDetail')
    },
    addVote() {
      this.$emit('addVote', this.userInfo.id)
    }
  },

  computed: {
    cName() {
      if (!this.searchMatch) {
        return this.userInfo.name;
      }
      let className = this.searchCurrent ? 'search-current' : 'search-match'
      return this.userInfo.name.replace(this.searchName, '<span class="' + className + '">' + this.searchName + '</span>')
    }
  }

}
</script>
<style lang='less' scoped>
    div{
        color: white;
        text-align: center;
        
    }
    .container{
      height: 300px;
      padding: 10px 0;
      width: 200px;
      flex-shrink: 0;
      margin-bottom: 10px;

      .name {
        height: 28px;
        line-height: 32px;
      }

      .avatar {
        cursor: pointer;
        width: 160px;
      }

      .posi {
        font-size: 12px;
        line-height: 30px;
        height: 32px;
        text-overflow: -o-ellipsis-lastline;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 1;
        -webkit-box-orient: vertical;
      }
        .zan {
          font-size: 16px;
          height: 24px;
          line-height: 24px;
          display: flex;
          justify-content: center;
          align-items: center;
          margin-bottom: 10px;

          img {
            height: 18px;
            width: 24px;
            margin-right: 5px;
            cursor: pointer;
          }
        }


    }
</style>
<style>
.search-match {
  display: inline-block;
  background-color: #ff0;
  color: black;
  line-height: 22px;
}

.search-current {
  display: inline-block;
  background-color: #ff9632;
  color: black;
  line-height: 22px;
}
</style>